 <!-- Page Header Start-->
 <div class="page-main-header">
    <div class="main-header-right row">
        <div class="main-header-left d-lg-none w-auto">
            <div class="logo-wrapper">
                <a href="index.html">
                    <img class="blur-up lazyloaded d-block d-lg-none"
                        src="assets/images/dashboard/multikart-logo-black.png" alt="">
                </a>
            </div>
        </div>
        <div class="mobile-sidebar w-auto">
            <div class="media-body text-end switch-sm">
                <label class="switch">
                    <a href="javascript:void(0)">
                        <i id="sidebar-toggle" data-feather="align-left"></i>
                    </a>
                </label>
            </div>
        </div>
        <div class="nav-right col">
            <ul class="nav-menus">
                <li>
                    <form class="form-inline search-form">
                        <div class="form-group">
                            <input class="form-control-plaintext" type="search" placeholder="Search..">
                            <span class="d-sm-none mobile-search">
                                <i data-feather="search"></i>
                            </span>
                        </div>
                    </form>
                </li>
                <li>
                    <a class="text-dark"  onclick="javascript:toggleFullScreen()">
                        <i data-feather="maximize-2"></i>
                    </a>
                </li>
                <li class="onhover-dropdown">
                    <a class="txt-dark" href="javascript:void(0)">
                        <h6>EN</h6>
                    </a>
                    <ul class="language-dropdown onhover-show-div p-20">
                        <li>
                            <a href="javascript:void(0)" data-lng="en">
                                <i class="flag-icon flag-icon-is"></i>English</a>
                        </li>
                        <li>
                            <a href="javascript:void(0)" data-lng="es">
                                <i class="flag-icon flag-icon-um"></i>Spanish</a>
                        </li>
                        <li>
                            <a href="javascript:void(0)" data-lng="pt">
                                <i class="flag-icon flag-icon-uy"></i>Portuguese</a>
                        </li>
                        <li>
                            <a href="javascript:void(0)" data-lng="fr">
                                <i class="flag-icon flag-icon-nz"></i>French</a>
                        </li>
                    </ul>
                </li>
                <li class="onhover-dropdown">
                    <i data-feather="bell"></i>
                    <span class="badge badge-pill badge-primary pull-right notification-badge">3</span>
                    <span class="dot"></span>
                    <ul class="notification-dropdown onhover-show-div p-0">
                        <li>Notification <span class="badge badge-pill badge-primary pull-right">3</span></li>
                        <li *ngFor="let item of listCommande">
                            <div class="media">
                                <div class="media-body">
                                    <h6 class="mt-0">
                                        <span>
                                            <i class="shopping-color" data-feather="shopping-bag"></i>
                                        </span> {{item.user.nom}}
                                    </h6>
                                    <p class="mb-0">{{item.Produit}}</p>
                                </div>
                            </div>
                        </li>
                     
                        <li class="txt-dark"><a href="javascript:void(0)">All</a> notification</li>
                    </ul>
                </li>
                <li>
                    <a href="javascript:void(0)">
                        <i class="right_side_toggle" data-feather="message-square"></i>
                        <span class="dot"></span>
                    </a>
                </li>
                <li class="onhover-dropdown">
                    <div class="media align-items-center">
                        <img class="align-self-center pull-right img-50 blur-up lazyloaded"
                            src="assets/ilyes.jpg" alt="header-user">
                        <div class="dotted-animation">
                            <span class="animate-circle"></span>
                            <span class="main-circle"></span>
                        </div>
                    </div>
                    <ul class="profile-dropdown onhover-show-div p-20 profile-dropdown-hover">
                       
                        <li>
                            <a (click)="logout()" >
                                <i data-feather="log-out"></i>Logout
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>
            <div class="d-lg-none mobile-toggle pull-right">
                <i data-feather="more-horizontal"></i>
            </div>
        </div>
    </div>
  </div>
  <!-- Page Header Ends -->
  